import React, {useState, useEffect, useRef} from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { Button, Divider, Input, Modal, notification, Popconfirm, Select, Space } from 'antd';
import { getItem, createItem, deleteItem } from '../../controller/Control';
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'moment/locale/es'  // Importar la localización en español de moment.js
import './styles.css'

const localizer = momentLocalizer(moment)

const messages = {
	allDay: 'Todo el día',
	previous: 'Anterior',
	next: 'Siguiente',
	today: 'Hoy',
	month: 'Mes',
	week: 'Semana',
	day: 'Día',
	agenda: 'Agenda',
	date: 'Fecha',
	time: 'Hora',
	event: 'Evento',
	showMore: (total: number) => `+ Ver más (${total})`
}

interface Event {
	_id: string
	id_user: string
	title: string
	start: Date
	end: Date
	description?: string
}

interface Patient {
	_id: string;
	name: string;
	document: string;
	createdAt: string;
	// Agrega otras propiedades según sea necesario
}

const Calendario: React.FC = () => {
	const [myEventsList, setMyEventsList] = useState<Event[]>([])
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [newEvent, setNewEvent] = useState({ id_user: '', title: '', description: '', start: new Date(), end: new Date() });
	const [ dataPatients, setDataPatients] = useState<Patient[]>([])
	const [userId, setUserId] = useState<string>('')
	const [patienceName, setPatienceName] = useState<string>('')
	const [filterPatienceName, setFilterPatienceName] = useState<string>('')

	const getCalendar = async () => {
		const user: any = sessionStorage.getItem('userData');
		const userJson = JSON.parse(user);
		const token = userJson.token;
	
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/calendar` || 'localhost:3000', token);
		
		const events = data.map((event: any) => ({
			...event,
			start: new Date(event.start),
			end: new Date(event.end),
		}));
	
		setMyEventsList(events);
	};
	

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/patient` || 'localhost:3000', token)
		setDataPatients(data)
	}

	useEffect(() => {
		getCalendar()
		getData()
	}, [0])

	const deleteEvent = async(event:any) => {
		Modal.confirm({
			title: '¿Estás seguro de que deseas eliminar este evento?',
			content: `Evento: ${event.title}`,  // Aquí puedes mostrar más detalles del evento
			okText: 'Eliminar',
			okType: 'danger',
			cancelText: 'Cancelar',
			centered: true,
			onOk: async () => {
				handleDelete(event)
			},
			onCancel() {
					console.log('Cancelado');
			}
		});
	}

	const handleDelete = async(event:any) => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await deleteItem(`${process.env.REACT_APP_API_SERVER}/calendar/${event._id}` || 'localhost:3000', token)
		if(Object.keys(data).length > 0){
			notification.destroy(`openNotification_${event._id}`)
			getCalendar()
		}
	}


	const openNotification = (event: Event) => {
		const data = dataPatients?.filter((x) => x._id === event.id_user)
		const name = data[0]?.name
		const notificationKey = `openNotification_${event._id}`;
		const btn = (
			<Space>
				<Button type="primary" size="small" onClick={() => deleteEvent(event)}>
					Eliminar
				</Button>
			</Space>
		);
		notification.info({
			message: (
        <>
            <h1>{name}</h1><br />
            Evento: {event.title}
        </>
    	),
			description: event.description || 'No hay descripción.',
			placement: 'top',
			showProgress: true,
			pauseOnHover: true,
			btn,
			key: notificationKey
		});
	};

	const handleSelectSlot = ({ start, end }: { start: Date; end: Date }) => {
		setNewEvent({ ...newEvent, start, end });
		setIsModalOpen(true);
	};

	const handleAddEvent = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await createItem(`${process.env.REACT_APP_API_SERVER}/calendar` || 'localhost:3000', newEvent, token)
		if(Object.keys(data).length > 0){
			setIsModalOpen(false);
			getCalendar()
			setNewEvent({ id_user: '', title: '', description: '', start: new Date(), end: new Date() })
			setPatienceName('')
		}
	};

	const filterByPatient = (value: string) => {
		const document = dataPatients.filter((x) => x._id === value)
		setFilterPatienceName(document[0].name)
		const filterEvents = myEventsList.filter((x) => x.id_user === value)
		setMyEventsList(filterEvents)
		setUserId(value)
	}

	const cleanFilter = () => {
		getCalendar()
		setFilterPatienceName('')
		setUserId('')
	}

	return (
		<div className="mt-3 myCustomHeight" style={{ height: '100vh' }}>
			<div>
				<Select 
					className='w-[350px] m-3' 
					placeholder="Filtrar por Paciente"
					value={userId}
					showSearch
					filterOption={(input, option: any) => 
						option?.children && typeof option.children === 'string' 
							? option.children.toLowerCase().includes(input.toLowerCase()) 
							: false // Asegúrate de que `children` no sea undefined
					} 
					onChange={filterByPatient} // Actualizar id_user con el valor seleccionado
				>
					{dataPatients.map((data: Patient) => (
						<Select.Option value={data._id} key={data._id}>{data.document}</Select.Option> // Usar el _id como value y name como texto visible
					))}
				</Select>
				<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-3 lg:mx-2 ocultarPrintDiv' onClick={cleanFilter}>Limpiar Filtro</button>
			</div>
			<div className='text-center text-lg text-blue-500 font-bold'>{filterPatienceName}</div>
			<Calendar
				culture="es"  // Establecer la cultura en español
				localizer={localizer}
				events={myEventsList}
				startAccessor="start"
				endAccessor="end"
				messages={messages}  // Pasar mensajes personalizados en español
				defaultView='day'
				style={{ height: '80vh' }}
				selectable
				onSelectEvent={(event: any) => openNotification(event)}
				onSelectSlot={handleSelectSlot}
			/>
			<Modal
        title="Agregar nuevo evento"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={handleAddEvent}
      >
				<div>Nombre: {patienceName}</div>
				<Select 
					className='w-full mb-3' 
					placeholder="Selecciona Paciente" 
					showSearch
					value={newEvent.id_user}
					filterOption={(input, option: any) => 
						option?.children && typeof option.children === 'string' 
							? option.children.toLowerCase().includes(input.toLowerCase()) 
							: false // Asegúrate de que `children` no sea undefined
					} 
					onChange={(value) => {
						setNewEvent({ ...newEvent, id_user: value });
						const document = dataPatients.filter((x) => x._id === value)
						setPatienceName(document[0].name)
					}} // Actualizar id_user con el valor seleccionado
				>
					{dataPatients.map((data: Patient) => (
						<Select.Option value={data._id} key={data._id}>{data.document}</Select.Option> // Usar el _id como value y name como texto visible
					))}
				</Select>
        <Input
          placeholder="Título del evento"
          value={newEvent.title}
          onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
					className='mb-3'
        />
				<Input
          placeholder="Descripción del evento"
          value={newEvent.description}
          onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
        />
      </Modal>
		</div>
	)
}

export default Calendario
